import { Component, OnInit } from '@angular/core';
import { societyPricesSimulationsPreconfig } from '@app/shared/interfaces/society-prices-simulations-preconfig';
import { societyPricesPreconfig } from '@app/shared/interfaces/society-prices-preconfig';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '@app/shared/services/alert.service';
import { SocietiesService } from '@app/shared/services/societies.service';
import { TarificationService } from '@app/shared/services/tarification.service';
import * as moment from 'moment';

@Component({
  selector: 'app-rate-management-vehicle',
  templateUrl: './rate-management-vehicle.component.html',
  styleUrls: ['./rate-management-vehicle.component.scss']
})
export class RateManagementComponentVehicle implements OnInit {

  public id: string = '0';
  public society: any = {};
  public prices: any = societyPricesPreconfig.config1;
  public simulations: any = [
    societyPricesSimulationsPreconfig.simulation1,
    societyPricesSimulationsPreconfig.simulation2,
    // societyPricesSimulationsPreconfig.simulation3,
    // societyPricesSimulationsPreconfig.simulation4,
  ];
  public formChanged: boolean = false;
  public loading: boolean = true;
  public tarificationHoursExist: boolean = false;
  public tarificationBlockExist: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private societyService: SocietiesService,
    private tarificationService: TarificationService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');

    this.societyService.getSociety(this.id).then((res) => {
      this.society = res;
      this.loading = false;
    });
    this.getTarification().then(() => {
      this.updateSimulations();
    });
  }

  async getTarification(): Promise<void> {
    this.prices = await this.setTarificationConfig(await this.tarificationService.getTarificationByVehicle(this.id));
    this.prices.tarificationType = 'internet';
    // this.prices.idVehicle = [this.id, '6807']
    this.prices.idVehicle = this.id
  }

  async setTarificationConfig(tarif): Promise<object> {
    if (tarif.hour_price_list) this.tarificationHoursExist = true;
    if (tarif.block_list) this.tarificationBlockExist = true;
    // if (!tarif.blocks && !tarif.hourPrices) this.alertService.error('Aucune tarification n\'a été trouvée pour ce véhicule');

    if (!tarif.block_list) tarif.block_list = societyPricesPreconfig.config1.block_list;
    if (!tarif.discount_list) tarif.discount_list = societyPricesPreconfig.config1.discount_list;
    if (!tarif.hour_price_list) tarif.hour_price_list = societyPricesPreconfig.config1.hour_price_list;
    if (!tarif.price_type) tarif.price_type = societyPricesPreconfig.config1.price_type;
    if (!tarif.limited_hour_day) tarif.limited_hour_day = societyPricesPreconfig.config1.limited_hour_day;
    if (!tarif.km_price) tarif.km_price = societyPricesPreconfig.config1.km_price;
    if (!tarif.reservation_price) tarif.reservation_price = societyPricesPreconfig.config1.reservation_price;
    if (!tarif.fuel_included) tarif.fuel_included = societyPricesPreconfig.config1.fuel_included;

    for (let i = 0; i < tarif.block_list.length; i++) {
      if (isNaN(tarif.block_list[i].start)) {
        tarif.block_list[i].start = parseInt(tarif.block_list[i].start.split(":")[0])
        tarif.block_list[i].end = parseInt(tarif.block_list[i].end.split(":")[0])
      }
    }

    return tarif
  }

  toDateString(date: Date): string {
    return (date.getFullYear().toString() + '-'
      + ("0" + (date.getMonth() + 1)).slice(-2) + '-'
      + ("0" + (date.getDate())).slice(-2))
      + 'T' + date.toTimeString().slice(0, 5);
  }

  // updatePriceFormFromModel(modelId) : void {
  //   switch (modelId) {
  //     case 1:
  //       this.prices = societyPricesPreconfig.config1;
  //       break;
  //     case 2:
  //       this.prices = societyPricesPreconfig.config2;
  //       break;
  //     case 3:
  //       this.prices = societyPricesPreconfig.config3;
  //       break;
  //     case 4:
  //       this.prices = societyPricesPreconfig.config4;
  //       break;
  //   }
  // }

  // Add discounts
  addDiscount(): void {
    this.prices.discount_list.push({
      amount: 0,
      symbol: '%',
      conditionAmount: 0,
      conditionAmountMax: 0,
      condition: 'kilometers'
    });
  }

  //remove discounts
  removeDiscount(index): void {
    this.prices.discount_list.splice(index, 1);
  }

  // 0. Simulation steps
  updateSimulation(index): void {
    this.setTotalTimeString(index);
    this.setKmAmount(index);
    this.setHourAmount(index);
    this.setReservationAmount(index);
    this.setDiscountAmount(index);
    this.setTotalAmount(index);
  }

  // 1. Kilometers
  setKmAmount(index): void {
    this.simulations[index].kmAmount = parseFloat((this.prices.km_price * this.simulations[index].kilometers).toFixed(2));
  }

  // 2. Hours
  blockIndexByDate(date): number {
    let hour = date.hours();

    for (let i = 0; i < this.prices.block_list.length; i++) {
      if (hour >= this.prices.block_list[i].start && hour < this.prices.block_list[i].end) {
        return i;
      }
    }
    return -1;
  }

  setHourAmount(index): void {
    let start = moment(this.simulations[index].start);
    let end = moment(this.simulations[index].end);
    let blockIndex = this.blockIndexByDate(start);
    let limitHours = 1;

    this.simulations[index].hourAmount = 0;
    if (this.prices.price_type === 'hour_prices') {
      while (end.diff(start, 'minutes') > 0) {
        if (limitHours <= this.prices.limited_hour_day) {
          this.simulations[index].hourAmount += this.prices.hour_price_list[start.isoWeekday() - 1];
        }

        limitHours = (limitHours === 24) ? 1 : limitHours + 1;
        start.add(1, 'hours');
      }
    }
    if (this.prices.price_type === 'blocks') {
      this.simulations[index].hourAmount += this.prices.block_list[blockIndex].amount;
      while (end.diff(start, 'minutes') > 0) {
        if (end.diff(start, 'minutes') < 60) {
          start.add(end.diff(start, 'minutes'), 'minutes');
        }
        if (end.diff(start, 'minutes') >= 60) {
          start.add(1, 'hours');
        }
        if (blockIndex !== this.blockIndexByDate(start)) {
          blockIndex = this.blockIndexByDate(start);
          this.simulations[index].hourAmount += this.prices.block_list[blockIndex].amount;
        }
      }
    }
    this.simulations[index].hourAmount = parseFloat(this.simulations[index].hourAmount.toFixed(2));
  }

  // 3. Reservation
  setReservationAmount(index): void {
    this.simulations[index].reservationAmount = parseFloat((this.prices.reservation_price).toFixed(2));
  }

  // 4. Discounts
  applyKilometersDiscount(discountConfig, index): void {
    let kilometers = this.simulations[index].kilometers;

    if (kilometers < discountConfig.conditionAmount) {
      return;
    }
    if (discountConfig.symbol === '€') {
      this.simulations[index].discountAmount += discountConfig.amount;
      return;
    }
    if (discountConfig.symbol === '%') {
      kilometers -= discountConfig.conditionAmount;
      kilometers = Math.min(kilometers, discountConfig.conditionAmountMax - discountConfig.conditionAmount);
      this.simulations[index].discountAmount += (this.prices.km_price * kilometers) * (discountConfig.amount / 100);
    }
  }

  applyHoursDiscount(discountConfig, index): void {
    let start = moment(this.simulations[index].start);
    let end = moment(this.simulations[index].end);
    let diffHours = end.diff(start, 'hour');
    let hoursCount = 0;
    let limitHours = 1;

    diffHours += (end.diff(start, 'minute') % 60 > 0) ? 1 : 0;
    if (discountConfig.symbol === 'km') {
      let included = Math.min(this.simulations[index].kilometers, discountConfig.amount * diffHours);

      this.simulations[index].discountAmount += included * this.prices.km_price;
    }
    if (diffHours < discountConfig.conditionAmount) {
      return;
    }



    if (discountConfig.symbol === '€') {
      this.simulations[index].discountAmount += discountConfig.amount;
      return;
    }
    if (discountConfig.symbol === '%') {
      while (end.diff(start, 'minutes') > 0) {
        if (limitHours <= this.prices.limited_hour_day && hoursCount >= discountConfig.conditionAmount && hoursCount < discountConfig.conditionAmountMax) {
          this.simulations[index].discountAmount += this.prices.hour_price_list[start.isoWeekday() - 1] * (discountConfig.amount / 100);
        }
        limitHours = (limitHours === 24) ? 1 : limitHours + 1;
        start.add(1, 'hours');
        hoursCount += 1;
      }
    }
  }

  applyBlocksDiscount(discountConfig, index): void {
    let start = moment(this.simulations[index].start);
    let end = moment(this.simulations[index].end);
    let blockIndex = this.blockIndexByDate(start);
    let blockCount = 1;

    if (discountConfig.symbol === '%'
      && blockCount >= discountConfig.conditionAmount
      && blockCount < discountConfig.conditionAmountMax) {
      this.simulations[index].discountAmount += this.prices.block_list[blockIndex].amount * (discountConfig.amount / 100);
    }
    while (end.diff(start, 'minutes') > 0) {
      if (end.diff(start, 'minutes') < 60) {
        start.add(end.diff(start, 'minutes'), 'minutes');
      }
      if (end.diff(start, 'minutes') >= 60) {
        start.add(1, 'hours');
      }
      if (blockIndex !== this.blockIndexByDate(start)) {
        blockIndex = this.blockIndexByDate(start);
        blockCount += 1;
        if (discountConfig.symbol === '%'
          && blockCount >= discountConfig.conditionAmount
          && blockCount < discountConfig.conditionAmountMax) {
          this.simulations[index].discountAmount += this.prices.block_list[blockIndex].amount * (discountConfig.amount / 100);
        }
      }
    }
    if (discountConfig.symbol === '€' && blockCount >= discountConfig.conditionAmount) {
      this.simulations[index].discountAmount += discountConfig.amount;
    }
    if (discountConfig.symbol === 'km') {
      let included = Math.min(this.simulations[index].kilometers, discountConfig.amount * blockCount);

      this.simulations[index].discountAmount += included * this.prices.km_price;
    }
  }

  setDiscountAmount(index): void {
    this.simulations[index].discountAmount = 0;
    for (let i = 0; i < this.prices.discount_list.length; i++) {
      switch (this.prices.discount_list[i].condition) {
        case 'kilometers':
          this.applyKilometersDiscount(this.prices.discount_list[i], index);
          break;
        case 'blocks':
          this.applyBlocksDiscount(this.prices.discount_list[i], index);
          break;
        case 'hours':
          this.applyHoursDiscount(this.prices.discount_list[i], index);
          break;
      }
    }
    this.simulations[index].discountAmount = parseFloat((this.simulations[index].discountAmount).toFixed(2));
  }

  // 5. Total
  setTotalAmount(index): void {
    this.simulations[index].totalAmount = parseFloat((this.simulations[index].hourAmount + this.simulations[index].kmAmount + this.simulations[index].reservationAmount - this.simulations[index].discountAmount).toFixed(2));
    if (this.simulations[index].totalAmount < 0) {
      this.simulations[index].totalAmount = 0;
    }
  }

  // Miscellaneous functions for simulations
  changeSymbol(i, value): void {
    if (this.prices.discount_list[i].symbol !== 'km' && value === 'km') {
      this.prices.discount_list[i].condition = 'hours';
    }
    this.prices.discount_list[i].symbol = value;
  }

  setTotalTimeString(index): void {
    let start = moment(this.simulations[index].start);
    let end = moment(this.simulations[index].end);
    let diffDay = end.diff(start, 'days');
    let diffHours = end.diff(start, 'hour') % 24;

    diffHours += (end.diff(start, 'minute') % 60 > 0) ? 1 : 0;
    this.simulations[index].totalTime = '';
    if (diffDay > 0) {
      this.simulations[index].totalTime += diffDay + ' jour';
      this.simulations[index].totalTime += (diffDay > 1) ? 's' : '';
    }
    if (diffDay > 0 && diffHours > 0) {
      this.simulations[index].totalTime += ' et ';
    }
    if (diffHours > 0) {
      this.simulations[index].totalTime += diffHours + ' heure';
      this.simulations[index].totalTime += (diffHours > 1) ? 's' : '';
    }
  }

  updateSimulations(): void {
    for (let i = 0; i < this.simulations.length; i++) {
      this.updateSimulation(i);
    }
  }

  async updateTarification(): Promise<void> {
    if (!this.checkPrices()) return;
    if (!this.checkRemise()) return;

    //Update la tarification apres la mise à jour des prix
    // this.updateSimulations();
    const infoUpdateTarif = await this.tarificationService.updateTarificationByVehicle(this.formatPrice(JSON.stringify(this.prices)));
    if (infoUpdateTarif.success) {
      this.alertService.alert('Mise à jour de la tarification');
      this.tarificationBlockExist = true;
    }
    else {
      this.alertService.error("Erreur lors de la mise à jour de la tarification");
    }
  }



  // "block_list": null,
  // "discount_list": null,
  // "fuel_included": 1,
  // "hour_price_list": [2.7, 2.7, 2.7, 2.7, 2.7, 2.7, 1],
  // "id_vehicle": 155,
  // "id_vehicle_price": 7,
  // "km_price": 0.4,
  // "limited_hour_day": 10,
  // "price_type": "hour_prices",
  // "reservation_price": 1.5,
  // "society_type": 0

  formatPrice(price): object {
    let formatPrice = JSON.parse(price);

    for (let i = 0; i < formatPrice.block_list.length; i++) {
      formatPrice.block_list[i].start = this.prices.block_list[i].start < 10 ? ("0" + this.prices.block_list[i].start + ":00:00") : (this.prices.block_list[i].start + ":00:00")
      formatPrice.block_list[i].end = this.prices.block_list[i].end < 10 ? ("0" + this.prices.block_list[i].end + ":00:00") : (this.prices.block_list[i].end + ":00:00")
    }

    return { ...formatPrice }
    // return { "vehicle_vop_price": formatPrice }
    // return { "vehicleVopPrice": formatPrice }
  }

  checkPrices(): boolean {
    //check discount
    if (!Number.isSafeInteger(this.prices.limited_hour_day)) {
      this.alertService.error('Le nombre d\'heures par jour doit être un entier');
      return false
    }

    return true
  }

  checkRemise(): boolean {
    //check discount
    for (let discount of this.prices.discount_list) {
      if ((discount.symbol === "%" || discount.symbol === "€") && discount.conditionAmountMax < discount.conditionAmount) {
        this.alertService.error('La condition maximum est inférieure à la condition minimum');
        return false
      }

      if ((discount.symbol === "%" || discount.symbol === "€") && discount.amount == 0 && discount.conditionAmount == 0 && discount.conditionAmountMax == 0) {
        this.alertService.error('Une reduction n\'a pas été définie');
        return false
      }
    }

    return true
  }

  // Add or remove simulations
  addSimulation(): void {
    this.simulations.push({
      start: this.toDateString(new Date()),
      end: this.toDateString(new Date()),
      kilometers: 0,
      totalTime: "",
      kmAmount: 0,
      hourAmount: 0,
      reservationAmount: 0,
      discountAmount: 0,
      totalAmount: 0
    });
  }

  removeSimulation(index): void {
    this.simulations.splice(index, 1);
  }
}
